import VoucherGlobal from '../../../../components/VoucherGlobal';

const GlobalVoucher = (props) => {
	const { voucherGlobalList, remainingNominal, handleVoucherDetail, setDataVoucherWarning, setIsShowWarningVoucher, handleUpdateVoucherList } = props;
	return (
		<>
			{voucherGlobalList?.map((voucher, index) => {
				return (
					<VoucherGlobal
						key={`voucher_global_${index}`}
						showLabelCount={false}
						type={'voucher_global'}
						data={voucher}
						handleUseVoucher={(data, type, warning) => {
							if (warning && type === "plus") {
								setDataVoucherWarning({
									code: data?.code,
									voucher_type: 'voucher_global',
									is_use: data.is_use ?? false,
									type: type,
								});
								setIsShowWarningVoucher(true);
							} else {
								handleUpdateVoucherList(data.id, 'voucher_global', data.is_use ?? false);
							}
						}}
						remainingNominal={remainingNominal}
						onOpenDetail={(type) => {
							handleVoucherDetail(true, voucher, type);
						}}
						isDisabled={voucher?.disabled}
            {...{ values: props?.values }}
					/>
				);
			})}
		</>
	);
};

export default GlobalVoucher;
